import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=9037e38a&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=ts"
export * from "./Reset.vue?vue&type=script&lang=ts"
import style0 from "./Reset.vue?vue&type=style&index=0&id=9037e38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9037e38a",
  null
  
)

export default component.exports